import { render, staticRenderFns } from "./DialogDraft.vue?vue&type=template&id=5d13c73e"
import script from "./DialogDraft.vue?vue&type=script&lang=js"
export * from "./DialogDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports